import { useAppSelector } from "app/redux-store-interactions";
import { selectIsOnline, selectSceneDbBackfill } from "slices/explorer";

/** Offline, the no-connection bar takes precedence and there is nothing to reload anyway. */
export function useIsSceneBackfillBarVisible(): boolean {
    const backfill = useAppSelector(selectSceneDbBackfill);
    const isOnline = useAppSelector(selectIsOnline);
    return (backfill.preparing || Boolean(backfill.ready)) && isOnline;
}
